// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-2d804b27] .custom-radio {\n  margin-bottom: 20px;\n}\n[data-v-2d804b27] .custom-radio .custom-control-label {\n  font-weight: 700;\n}", ""]);
// Exports
module.exports = exports;
